import IconBadge from './IconBadge';

function AnnouncementCard({ announcement, onOpen }) {
  const identifier = announcement.identifier || announcement.id;

  return (
    <article className="announcement-card">
      <button
        type="button"
        className="announcement-card__trigger"
        onClick={() => onOpen(announcement, identifier)}
      >
        <IconBadge
          icon={announcement.icon}
          className={`announcement-card__icon announcement-card__icon--${announcement.icon}`}
        />
        <div>
          <h3>{announcement.title}</h3>
          <p>{announcement.description}</p>
        </div>
      </button>
    </article>
  );
}

export default AnnouncementCard;
